__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-peer-payments-partner-root'].baseUrl;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// eslint-disable-next-line import/no-named-as-default -- have no idea why this became a lint issue
import AxpPeerPaymentsPartnerRoot from './components/AxpPeerPaymentsPartnerRoot';
import './iguazu-rest/config';
export default AxpPeerPaymentsPartnerRoot;
;
if (!global.BROWSER) {
  AxpPeerPaymentsPartnerRoot.appConfig = Object.assign({}, AxpPeerPaymentsPartnerRoot.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
AxpPeerPaymentsPartnerRoot.appConfig = Object.assign({}, AxpPeerPaymentsPartnerRoot.appConfig, {
  providedExternals: {
    'iguazu': _objectSpread(_objectSpread({}, {
      "fallbackEnabled": false,
      "enableFallback": false
    }), {}, {
      version: '3.2.0',
      module: require('iguazu')
    }),
    'iguazu-holocron': _objectSpread(_objectSpread({}, {
      "fallbackEnabled": false,
      "enableFallback": false
    }), {}, {
      version: '1.8.2',
      module: require('iguazu-holocron')
    }),
    'iguazu-rest': _objectSpread(_objectSpread({}, {
      "fallbackEnabled": false,
      "enableFallback": false
    }), {}, {
      version: '1.11.1',
      module: require('iguazu-rest')
    }),
    '@americanexpress/react-ddl': _objectSpread(_objectSpread({}, {
      "fallbackEnabled": false,
      "enableFallback": false
    }), {}, {
      version: '0.3.7',
      module: require('@americanexpress/react-ddl')
    }),
    '@americanexpress/data-manager-utils': _objectSpread(_objectSpread({}, {
      "fallbackEnabled": false,
      "enableFallback": false
    }), {}, {
      version: '0.4.5',
      module: require('@americanexpress/data-manager-utils')
    })
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'axp-peer-payments-partner-root') {
  global.getTenantRootModule = function () {
    return AxpPeerPaymentsPartnerRoot;
  };
  global.rootModuleName = 'axp-peer-payments-partner-root';
}